import { Typography } from "@mui/material";
import React from "react";
export const ModalSheetTitle = ({ children }) => (React.createElement(Typography, { variant: "h3", sx: { pt: 1.5, pb: 3, hyphens: "none" } }, children));
//# sourceMappingURL=modal-sheet-title.js.map